import Vue from "vue";
import page from "@/pages/Default/CloudPrint/Welcome";
import {i18n} from "@/libraries/i18n/main";

new Vue({
    i18n,
    render: h => h(page, {
        props: {
            /* global $response */
            response: $response,
        }
    }),
}).$mount('#app');